import * as v from "valibot";

// request
export const QueryRequestSchema = v.object({
  Action: v.nullish(v.string()),
  ClusterId: v.string(),
  ComponentName: v.string(),
  IsRollBack: v.nullish(v.boolean()),
  Version: v.nullish(v.string()),
});
export type QueryRequest = v.InferOutput<typeof QueryRequestSchema>;

export const ArgSchema = v.object({
  Name: v.nullish(v.string()),
  Value: v.nullish(v.string()),
});
export type Arg = v.InferOutput<typeof ArgSchema>;

export const BodyRequestSchema = v.object({
  Args: v.array(ArgSchema),
});
export type BodyRequest = v.InferOutput<typeof BodyRequestSchema>;

// response
export const BodyArgSchema = v.object({
  Name: v.string(),
  Value: v.string(),
});
export type BodyArg = v.InferOutput<typeof ArgSchema>;

export const ComponentSchema = v.object({
  Args: v.nullish(v.array(ArgSchema)),
  Type: v.string(),
});
export type Component = v.InferOutput<typeof ComponentSchema>;

export const DataSchema = v.object({
  ClusterId: v.nullish(v.string()),
  ClusterName: v.nullish(v.string()),
  ComponentName: v.nullish(v.string()),
  Components: v.nullish(v.array(v.nullable(ComponentSchema))),
  ParamVersion: v.nullish(v.string()),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: v.nullish(DataSchema),
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
